module.exports = __webpack_public_path__ + "img/Slice3.78a189ef.png";